export const getDefaultSorted = [
  {
    dataField: 'position',
    order: 'desc',
  },
];

export const getPageOptions = (totalLength = 0) => ({
  sizePerPage: totalLength,
  totalSize: totalLength,
  custom: true,
});
